import { useCallback } from 'react';

import { useNavigateToMainTabs } from '../../navigation/AppNavigation.hooks';
import { useLastInteractedStore } from './useLastInteractedStore';

/**
 * Navigates to the last interacted store if available.
 * Fallback is to navigate to the menu tab itself.
 */
export const useNavigateToLastInteractedStore = () => {
  const navigateToMainTabs = useNavigateToMainTabs();

  const lastInteractedStore = useLastInteractedStore();
  const { restaurantSlug = '', addressId } = lastInteractedStore ?? {};

  return useCallback(() => {
    if (restaurantSlug) {
      void navigateToMainTabs('MenuTab', {
        screen: 'Menu',
        params: { restaurantSlug },
      });

      return;
    }

    if (addressId) {
      void navigateToMainTabs('MenuTab', {
        screen: 'DeliveryMenu',
        params: { addressId },
      });

      return;
    }

    void navigateToMainTabs('MenuTab');
  }, [addressId, navigateToMainTabs, restaurantSlug]);
};
